import { render } from "./App.vue?vue&type=template&id=38f430d1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=38f430d1&lang=scss"

import exportComponent from "/var/www/html/rhr-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__